export class ParkSiteMapPin {
  public I: string | null = null
  public L: number | null = null
  public N: number | null = null
  public S: string | null = null
  constructor(data?: Partial<ParkSiteMapPin>) {
    Object.assign(this, data)
  }
}
